export enum ErrorCode {
    /** 程序非预期异常 */
    Exception = -1,

    /** 拉取模板异常 */
    FetchTemplateErr = 101,
    /** 生成 sse 请求抛错 */
    ServerGenerationErr = 102,

    /** 插入备注：生成的演讲稿无法匹配对应页面 */
    NoteNotMatchErr = 201,

    /** 修改字体：输入字体为空或不合法 */
    InvalidFont = 301,
    /** 修改字体：应用的 slide 不存在 */
    SlideNotExist = 302,
}

const errorMsgMap: Record<ErrorCode, string> = {
    [ErrorCode.Exception]: 'exception',
    [ErrorCode.FetchTemplateErr]: 'fetch template failed',
    [ErrorCode.ServerGenerationErr]: 'receive error from slide:generation',
    [ErrorCode.NoteNotMatchErr]: 'generation note cannot match any slide',
    [ErrorCode.InvalidFont]: 'no corresponding font',
    [ErrorCode.SlideNotExist]: 'slide not exist',
};

export class ApiError extends Error {
    public constructor(public code: ErrorCode, message?: string) {
        super(message ?? errorMsgMap[code]);
        this.code = code;
        this.name = 'ApiError';
    }
}
